
import React from "react";

export const Overlay = () => {
    return (
        <React.Fragment>
            <div className="loading-overlay">
                <div className="spinner-container">
                    <img src={`${process.env.PUBLIC_URL}/assets/image/loading.gif`} alt="Loading..." />
                </div>
            </div>
        </React.Fragment>
    );
};